export default {
  name: "Madhu chandha Manikanthan",
  feedback: `Salem cake craft studio is very professional and gem of salem. 
  I learnt almost like 10-15 classes of different pastries here. Ramya mam is very knowledgeable, professional, humble mentor. 
  I learn basic to advance in baking, pastries, pizzas, icecream, chocolate and much more recipes made for home baking with genuine and business ethics. 
  I would recommend everyone to learn from salem craft studio for home baking and business purposes . 
  Worth and most valuable classes from salem craft studio.
`
};
